module.exports = __webpack_public_path__ + "static/media/RTO,CIR,RTS.ce05b400.ppt";